module.exports = __webpack_public_path__ + "static/media/undraw_wallet_aym5.b295ab55.png";